import React from 'react';

import IosShareIcon from '@mui/icons-material/IosShare';
import { IconButton, Tooltip } from '@mui/material';

import { classes } from './Dropdowns/styles';

const ExportCsvButton = ({ isOpen, onClick }: { isOpen: boolean; onClick: () => void }) => (
  <Tooltip arrow placement="top" title="Export CSV">
    <IconButton
      id="export-csv-button"
      onClick={onClick}
      sx={isOpen ? { ...classes.iconButton, ...classes.iconButtonOpen } : classes.iconButton}
    >
      <IosShareIcon />
    </IconButton>
  </Tooltip>
);

export default ExportCsvButton;
